module.exports = __webpack_public_path__ + "img/vertical_6_4_6000.fb2a5501.png";